(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './AuthFlowProvider', './PrivateRoute', './PrivateRouteGatsby', './RedirectToLogout', './withAuthProvider', './utils'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./AuthFlowProvider'), require('./PrivateRoute'), require('./PrivateRouteGatsby'), require('./RedirectToLogout'), require('./withAuthProvider'), require('./utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.AuthFlowProvider, global.PrivateRoute, global.PrivateRouteGatsby, global.RedirectToLogout, global.withAuthProvider, global.utils);
    global.index = mod.exports;
  }
})(this, function (exports, _AuthFlowProvider, _PrivateRoute, _PrivateRouteGatsby, _RedirectToLogout, _withAuthProvider, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PGA_TOKEN_NAME = exports.clearToken = exports.getToken = exports.setToken = exports.withAuthProvider = exports.redirectToLogout = exports.RedirectToLogout = exports.RedirectToLogin = exports.PrivateRouteGatsby = exports.PrivateRoute = exports.AuthConsumer = exports.AuthProvider = exports.AuthFlowProvider = undefined;

  var _AuthFlowProvider2 = _interopRequireDefault(_AuthFlowProvider);

  var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);

  var _PrivateRouteGatsby2 = _interopRequireDefault(_PrivateRouteGatsby);

  var _RedirectToLogout2 = _interopRequireDefault(_RedirectToLogout);

  var _withAuthProvider2 = _interopRequireDefault(_withAuthProvider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.AuthFlowProvider = _AuthFlowProvider2.default;
  exports.AuthProvider = _AuthFlowProvider.AuthProvider;
  exports.AuthConsumer = _AuthFlowProvider.AuthConsumer;
  exports.PrivateRoute = _PrivateRoute2.default;
  exports.PrivateRouteGatsby = _PrivateRouteGatsby2.default;
  exports.RedirectToLogin = _PrivateRoute.RedirectToLogin;
  exports.RedirectToLogout = _RedirectToLogout2.default;
  exports.redirectToLogout = _RedirectToLogout.redirectToLogout;
  exports.withAuthProvider = _withAuthProvider2.default;
  exports.setToken = _utils.setToken;
  exports.getToken = _utils.getToken;
  exports.clearToken = _utils.clearToken;
  exports.PGA_TOKEN_NAME = _utils.PGA_TOKEN_NAME;
});